<template>
    <v-container fluid>
        <v-layout row wrap >
            <v-flex xs12 sm6>
                <v-select
                        :label="this.$i18n.t('site.common.enter') + ' ' + this.$i18n.t('site.common.username')"
                        autocomplete
                        :loading="loading"
                        item-text="username"
                        max-height="200px"
                        dense
                        :items="items"
                        :rules="[() => select.length > 0 || 'Type in your username, if you have accounts on multiple servers, pick the one you want to view site as now.  You can change at any time']"
                        :search-input.sync="search"
                        v-model="select"
                        no-data-text="No Usernames Found"
                        append-icon="search"
                >
                    <template slot="item" slot-scope="data">
                        <template v-if="typeof data.item !== 'object'">
                            <v-list-tile-content v-text="data.item"></v-list-tile-content>
                        </template>
                        <template v-else>
                            <v-list-tile-avatar>
                                <elv-avatar-icon :avatar="data.item.avatar" :isFriend="data.item.isFriend" width="32"/>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title v-html="data.item.username"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="(data.item.fellowship||'No Fellowship') + ', ' + data.item.serverName + ', ' + data.item.currScore"></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </template>
                    </template>
                </v-select>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import _ from 'lodash';
    let elvenStats = require('../lib/elven-stats');
    import axios from 'axios';
    import ElvAvatarIcon from "./ElvAvatarIcon"
    export default {
        components: {ElvAvatarIcon},
        name: "elv-player-search-box",
        props: {
            'jumpToEnabled':{required:false, default: false},
            'emitViewAsPlayer':{required:false, default: false},
        },
        data () {
            return {
                loading: false,
                items: [],
                search: null,
                select: [],
                player: {},
                queryDebounced: _.debounce(this.querySelections, 250),
            }
        },
        watch: {
            search (val) {
                val && this.queryDebounced(val)
            },
            select(val) {
                console.log("Select modified!", val);

                if( this.jumpToEnabled ) {
                    this.$ga.event('PlayerSearch', 'Selected', "", "");
                    this.$router.push({ name: 'PlayerDetail',
                        params: { server: val.server, playerId: val.playerId }});
                }
                this.player = val;

                if( this.emitViewAsPlayer ) {
                    Event.$emit("viewAsPlayer", val);
                    this.$ga.event('PlayerSelection', 'Set', val.server, 1);
                }
            }
        },
        methods: {
            querySelections (v) {
                this.loading = true
                let self = this;
                axios.get(`/api/player/lookup`, { params: { q: v} }).then( function(response) {
                    try {
                        console.log("Got results for query: ",response.data);
                        let items = response.data;
                        _.each(items, function (item) {
                            item.serverName = elvenStats.mapDomainAndServerName(item.server);
                        });

                        self.items = items;

                        // if( _.size(self.items) === 0 ) {
                        //     self.items = [{username: "No Results Found"}]
                        // }
                        self.loading = false;
                        self.$ga.event('PlayerSearch', 'Queried', "", "");
                    }catch(err) {
                        console.error("Search error: " + err);
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ElvPlayerSearchBox.vue